import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const PageHeader = ({ eyebrow, title, text, breadcrumb }) => (
  <section className="relative bg-navy-deep grain overflow-hidden">
    <div className="absolute inset-0 dot-grid opacity-30" aria-hidden="true" />
    <div className="absolute -top-32 right-0 w-[500px] h-[400px] bg-brand/15 blur-[130px] rounded-full" aria-hidden="true" />
    <div className="relative max-w-8xl mx-auto px-6 lg:px-12 pt-40 pb-20 lg:pt-52 lg:pb-28">
      {breadcrumb && (
        <nav aria-label="Breadcrumb" data-testid="breadcrumb-nav" className="mb-6 flex flex-wrap items-center gap-2 text-xs uppercase tracking-[0.2em] text-mist/40">
          {breadcrumb.map((b, i) => (
            <span key={b.label} className="flex items-center gap-2">
              {i > 0 && <span aria-hidden="true">/</span>}
              {b.to ? (
                <Link to={b.to} className="hover:text-electric transition-colors">{b.label}</Link>
              ) : (
                <span className="text-electric">{b.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}
      {eyebrow && (
        <p data-testid="page-header-eyebrow" className="text-xs md:text-sm uppercase tracking-[0.25em] text-electric font-medium mb-6">
          {eyebrow}
        </p>
      )}
      <div className="overflow-hidden">
        <motion.h1
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          data-testid="page-header-title"
          className="font-display font-extrabold tracking-tighter leading-[1.0] text-5xl md:text-6xl lg:text-8xl text-mist max-w-5xl"
        >
          {title}
        </motion.h1>
      </div>
      {text && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7 }}
          className="mt-8 text-base md:text-lg text-slatec max-w-2xl leading-relaxed"
        >
          {text}
        </motion.p>
      )}
    </div>
  </section>
);

export default PageHeader;
